import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const list = css`
  margin: 1rem 0 0 1rem;
  list-style: disc;
`;

export const body = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 50rem;
`;

export const bodyTop = css`
  text-align: center;
`;

export const button = css`
  width: 100%;

  @media (min-width: ${dimensions.tablet}) {
    width: auto;
    display: flex;
    align-self: flex-end;
  }
`;
